<template>
  <b-card no-body :header="title" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">

    <b-list-group flush>
      <b-list-group-item>{{ listdata.length==0?'':listdata[0].result }} <b-img v-if="color==''?false:true" :src="ColorToImg(color)" fluid  class="p-2 ClothIcon float-right" ></b-img></b-list-group-item>
    </b-list-group>

  </b-card>


</template>
<style>
  .ClothIcon{
    width: 60px;
    height: 60px;
  }
</style>
<script>

export default {
  name: 'PlusClothCard',
  props: {
    listdata:Array,
    color:String,
    title:String
  },
  computed:{

  },
  data() {
    return {

    }
  },
  methods: {
    ColorToImg (color) {
      let setcolor = color
      let clothsrc = ''
      switch (setcolor) {
        case '白':
          clothsrc = require('../assets/ui/cwhite.png')
          break
        case '黑':
          clothsrc = require('../assets/ui/cblack.png')
          break
        case '綠':
          clothsrc = require('../assets/ui/cgreen.png')
          break
        case '咖啡':
          clothsrc = require('../assets/ui/ccoffee.png')
          break
        case '藍':
          clothsrc = require('../assets/ui/cblue.png')
          break
        case '紅':
          clothsrc = require('../assets/ui/cred.png')
          break
        case '黃':
          clothsrc = require('../assets/ui/cyellow.png')
          break

      }
      return clothsrc
    },

  }
}
</script>
